const EPIC_LOGIN_PATH_FRAGMENT = 'epic/login';
const EPIC_LAUNCH_QUERY_PARAM = 'launch';

// True when the current URL is an Epic SMART launch hop whose only job is to redirect to the
// OAuth provider (path contains `epic/login` and carries a `launch` code). On these hops the
// standalone redirect script navigates away, so booting the SPA is wasted work. The Epic
// *callback* (which carries `code`, not `launch`) is intentionally not matched, so the app
// still boots there to exchange the code.
export function isEpicLoginRedirectHop(): boolean {
	if (!globalThis.location.pathname.toLowerCase().includes(EPIC_LOGIN_PATH_FRAGMENT)) {
		return false;
	}

	return new URLSearchParams(globalThis.location.search).has(EPIC_LAUNCH_QUERY_PARAM);
}
